module.exports = __webpack_public_path__ + "img/feature_buy_en.1ab85912.png";